const keyboardDatePickerModalDocCompany = {
  label: 'Shelf life'
};

export default keyboardDatePickerModalDocCompany;
